import type { ColumnDef } from "@tanstack/react-table";
import type { PayrollRosterMember, PayrollTeam } from "@/payroll/roster/types";
import { rosterTeamNames } from "@/payroll/teams/utils";
import { TEAM_COLUMN_WIDTH } from "./column-widths";
import { rosterColumnHeader } from "./header";
import { RosterCellValue } from "./roster-cell-value";

export const TeamCol = <T extends { member: PayrollRosterMember }>(
  teams: readonly PayrollTeam[] = [],
): ColumnDef<T> => ({
  id: "payroll-teams",
  header: rosterColumnHeader("Teams"),
  enableSorting: false,
  meta: { size: `${TEAM_COLUMN_WIDTH}px` },
  cell: ({ row }) => (
    <RosterCellValue
      value={rosterTeamNames(row.original.member, teams) || "Unassigned"}
    />
  ),
});
